/**
 * Sections of the body of a quote (proposal Listini §7): the lines inserted
 * with «Compila da listino» stay together under a name, with their subtotal,
 * and move as one block. The body keeps a single order of lines: a section is
 * the run of its lines, which never mixes with the others.
 */
/** The body as blocks, in order: the lines of a section together, the others one by one. */
export function bodyBlocks(lines) {
    const blocks = [];
    for (const line of lines) {
        const last = blocks.at(-1);
        if (line.sectionId !== null && last?.sectionId === line.sectionId)
            last.lines.push(line);
        else
            blocks.push({ sectionId: line.sectionId, lines: [line] });
    }
    return blocks;
}
/** Whether every section has its lines one after the other. */
export function sectionsContiguous(lines) {
    const seen = new Set();
    for (const block of bodyBlocks(lines)) {
        if (block.sectionId === null)
            continue;
        if (seen.has(block.sectionId))
            return false;
        seen.add(block.sectionId);
    }
    return true;
}
/**
 * The order of the lines after moving `item` one place up (-1) or down (+1):
 * a section moves past the block next to it, a line of a section stays inside
 * it, a line on its own moves past a whole section. Null when it cannot move.
 */
export function moveInBody(lines, item, direction) {
    const blocks = bodyBlocks(lines);
    const flat = (list) => list.flatMap((block) => block.lines.map((line) => line.id));
    const swapBlocks = (index) => {
        const target = index + direction;
        if (index < 0 || target < 0 || target >= blocks.length)
            return null;
        const moved = [...blocks];
        [moved[index], moved[target]] = [moved[target], moved[index]];
        return flat(moved);
    };
    if ('section' in item) {
        return swapBlocks(blocks.findIndex((block) => block.sectionId === item.section));
    }
    const index = blocks.findIndex((block) => block.lines.some((line) => line.id === item.line));
    const block = blocks[index];
    if (!block)
        return null;
    if (block.sectionId === null)
        return swapBlocks(index);
    const position = block.lines.findIndex((line) => line.id === item.line);
    const target = position + direction;
    if (target < 0 || target >= block.lines.length)
        return null;
    const inside = [...block.lines];
    [inside[position], inside[target]] = [inside[target], inside[position]];
    const moved = [...blocks];
    moved[index] = { ...block, lines: inside };
    return flat(moved);
}
/** The name proposed for a new section: «Sviluppo», then «Sviluppo (2)», «Sviluppo (3)»… */
export function nextSectionName(base, taken) {
    const names = new Set(taken.map((name) => name.trim().toLowerCase()));
    if (!names.has(base.trim().toLowerCase()))
        return base;
    for (let count = 2;; count++) {
        const name = `${base} (${count})`;
        if (!names.has(name.toLowerCase()))
            return name;
    }
}
//# sourceMappingURL=quote-sections.js.map